import RoleModelCommunication from '~/pages/communication/roleModel/libs/components/RoleModelCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const RoleModelCommunicationPage = (props: TPageProps) => (
  <RoleModelCommunication {...props} />
)

export default RoleModelCommunicationPage
